import type { IParagraphEntry } from "~/models/IUserEntry";

export function useAddLocalEntriesForParagraph<T extends IParagraphEntry>(
  entries: MaybeRefOrGetter<Array<T | undefined>>,
  paragraphId: MaybeRefOrGetter<number | undefined>,
  type?: T["type"]
) {
  const localEntries = useLocalEntries();

  const amended = computed(() => {
    const cpy = [...(toValue(entries) ?? [])];
    const paragraphEntries = localEntries.value
      .filter(
        (localEntry) =>
          localEntry.data.legal_text_paragraph_id === toValue(paragraphId) &&
          (!type || localEntry.data.type === type)
      )
      .map((localEntry) => localEntry.data);
    cpy.push(...(paragraphEntries as T[]));

    return cpy as T[];
  });

  return { amended };
}
